export type OnboardingCountryCode = 'US' | 'CA' | 'IN' | 'GB' | 'OTHER';

export type OnboardingCurrencyCode = 'USD' | 'CAD' | 'INR' | 'GBP';

export type OnboardingAsset = {
  type: string;
  label: string;
  value: number;
  isInvestment: boolean;
  expectedReturnPct?: number;
};

export type OnboardingLiability = {
  type: string;
  label: string;
  balance: number;
  interestRatePct?: number;
  monthlyPayment?: number;
  monthlyInterest?: number;
  monthlyPrincipal?: number;
};

export type OnboardingSpendCategory = {
  categoryId: string;
  amount: number;
};

export type OnboardingDraft = {
  countryCode: OnboardingCountryCode;
  /** Display / entry currency — auto-set from country; sample JSON is not converted. */
  currencyCode: OnboardingCurrencyCode;
  monthlyIncomeAfterTax: number;
  assets: OnboardingAsset[];
  liabilities: OnboardingLiability[];
  expectedSpendByCategory: OnboardingSpendCategory[];
  dismissedModal: boolean;
  completedIntro: boolean;
  step: number;
};

export const ONBOARDING_STEP = {
  INTRO: 0,
  COUNTRY_INCOME: 1,
  ASSETS: 2,
  LIABILITIES: 3,
  SPEND: 4,
  UPLOAD: 5,
} as const;

export const ONBOARDING_LAST_STEP = ONBOARDING_STEP.UPLOAD;
